import React from 'react';
import { SerializedMediaWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../../common/types';
import { WidgetListItemProps } from '../props';
import { MediaBlockThumb } from './MediaBlockThumb';

/** The picture of a Media block in a list. */
const MediaWidgetListItemComponent: React.FC<WidgetListItemProps<SerializedMediaWidget>> = ({ widget }) => (
  <MediaBlockThumb media={widget.data.media} />
);

export const MediaWidgetListItem = TypedMemo(MediaWidgetListItemComponent);
